/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title: shouyin.ts
 * @Package: 南瓜头生鲜收银系统
 * @author: 飞贷金融科技
 * @date: 2025/06/12 11:03:00
 * @version: V1.0
 * @Copyright: 2019 www.feidai.com Inc. All rights reserved.
 * @Belong To: 飞贷金融科技
 * 注意：本内容仅限于深圳中兴飞贷金融科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import { axiosAPIUrl, Parameter } from "@/api/index";

// 1.7 MA007-获取卡券列表 getTicketList
export function getTicketList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxMarketingActivity/getTicketList",
    method: "get",
    params: parameter,
  });
}

// 1.8 MA008-获取兑奖券详情 getPrizeTicketDtl
export function getPrizeTicketDtl(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxMarketingActivity/getPrizeTicketDtl",
    method: "get",
    params: parameter,
  });
}
